// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Splitting from 'splitting';

gsap.registerPlugin(ScrollTrigger);

const initializedBlurElements = new WeakSet();
const blurAnimationHandles = new WeakMap();
const gradientTrackTitleSelector = [
  'h1[data-blur-splitting]',
  'h2[data-blur-splitting]',
  'h3[data-blur-splitting]',
  'h4[data-blur-splitting]',
  'h5[data-blur-splitting]',
  'h6[data-blur-splitting]',
].join(', ');
const gradientTrackElements = new Set();
let gradientTrackFrame = null;
let gradientTrackObserver = null;

const getScopedElements = (scope, selector) => {
  if (!scope) {
    return [];
  }

  if (typeof scope.matches === 'function' && scope.matches(selector)) {
    return [scope];
  }

  if (typeof scope.querySelectorAll !== 'function') {
    return [];
  }

  return Array.from(scope.querySelectorAll(selector));
};

function getGradientTrackElements(scope) {
  return getScopedElements(scope, gradientTrackTitleSelector).flatMap((title) =>
    Array.from(title.querySelectorAll('.gradient-cl-animate'))
  );
}

function updateGradientTrack(element) {
  const words = element.querySelectorAll('.word');

  if (!words.length) {
    return;
  }

  const trackRect = element.getBoundingClientRect();

  if (!trackRect.width) {
    return;
  }

  const trackSize = `${trackRect.width * 4}px auto`;

  words.forEach((word) => {
    const wordRect = word.getBoundingClientRect();
    const offsetX = trackRect.left - wordRect.left;

    word.style.setProperty('--gradient-track-size', trackSize);
    word.style.setProperty('--gradient-track-offset-x', `${offsetX}px`);
  });
}

function updateGradientTracks() {
  gradientTrackElements.forEach((element) => {
    if (!element.isConnected) {
      gradientTrackObserver?.unobserve(element);
      gradientTrackElements.delete(element);
      return;
    }

    updateGradientTrack(element);
  });
}

function scheduleGradientTrackUpdate() {
  if (gradientTrackFrame !== null) {
    return;
  }

  gradientTrackFrame = window.requestAnimationFrame(() => {
    gradientTrackFrame = null;
    updateGradientTracks();
  });
}

function registerGradientTracks(scope) {
  getGradientTrackElements(scope).forEach((element) => {
    gradientTrackElements.add(element);
    gradientTrackObserver?.observe(element);
    updateGradientTrack(element);
  });
}

function unregisterGradientTracks(scope) {
  getGradientTrackElements(scope).forEach((element) => {
    gradientTrackObserver?.unobserve(element);
    gradientTrackElements.delete(element);
  });
}

if (typeof ResizeObserver !== 'undefined') {
  gradientTrackObserver = new ResizeObserver(scheduleGradientTrackUpdate);
}

window.addEventListener('resize', scheduleGradientTrackUpdate, { passive: true });

const trackBlurAnimationHandle = (element, handle) => {
  if (!handle) {
    return;
  }

  const handles = blurAnimationHandles.get(element) || [];
  handles.push(handle);
  blurAnimationHandles.set(element, handles);
};

window.destroyScrollBlurAnimation = function destroyScrollBlurAnimation(
  scope = document
) {
  getScopedElements(scope, '[data-blur-splitting]').forEach((element) => {
    blurAnimationHandles.get(element)?.forEach((handle) => handle.kill());
    blurAnimationHandles.delete(element);
    initializedBlurElements.delete(element);
    unregisterGradientTracks(element);
  });
};

window.initScrollBlurAnimation = function initScrollBlurAnimation(scope = document) {
  const elements = getScopedElements(scope, '[data-blur-splitting]');

  const gradientLineElsArr = getScopedElements(
    scope,
    '.gradient-cl-animate.if-line-animation'
  );

  gradientLineElsArr.forEach((element) => {
    const innerText = element.textContent.trim();
    element.style.setProperty('--element-text', `"${innerText}"`);
    element.setAttribute('data-element-text', innerText);
  });

  elements.forEach((element) => {
    if (window.innerWidth <= 1024 && element.matches('.text-digital-sec__label')) {
      return;
    }

    if (initializedBlurElements.has(element)) {
      return;
    }

    initializedBlurElements.add(element);

    const parentSection = element.closest('section');

    Splitting({
      target: element,
      by: 'words',
    });

    registerGradientTracks(element);

    const words = element.querySelectorAll('.word');

    if (window.innerWidth >= 1025) {
      const wrapper = element.parentElement;
      const isUp = element.hasAttribute('data-blur-splitting-to-up');
      const isDown = element.hasAttribute('data-blur-splitting-to-bottom');
      const isLeft = element.hasAttribute('data-blur-splitting-to-left');
      const isFromUpToStart = element.hasAttribute(
        'data-blur-splitting-from-up-to-start'
      );

      let startY = 130;
      let endY = 20;

      let startTrigger = 70;
      let endTrigger = 50;

      /*if (window.innerWidth <= 1024) {
        startY = 50;
        endY = 20;
        startTrigger = 90;
        endTrigger = 40;
      }*/

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: `top-=${startY}vh ${startTrigger}%`,
          end: `bottom+=${endY}vh ${endTrigger}%`,
          scrub: 0.8,
          // markers: true,
          /*onUpdate: (self) => {
            const progress = self.progress;

            if (isDown) {
              element.style.transform = `translateY(${gsap.utils.interpolate(
                -10,
                15,
                progress
              )}vh)`;
            }

            if (isUp) {
              element.style.transform = `translateY(${gsap.utils.interpolate(
                15,
                -10,
                progress
              )}vh)`;
            }
          },*/
        },
      });
      trackBlurAnimationHandle(element, tl);

      let startYTransform = 100;
      let endYTransform = 0;

      let startTriggerTransform = 60;
      let endTriggerTransform = 0;

      const tlTransform = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: `top-=${startYTransform}vh ${startTriggerTransform}%`,
          end: `bottom+=${endYTransform}vh ${endTriggerTransform}%`,
          scrub: 0.8,
          // markers: true,
          onUpdate: (self) => {
            const progress = self.progress;

            if (isDown) {
              const attrValue = element.getAttribute(
                'data-blur-splitting-to-bottom'
              );

              let start = -10;
              let end = 15;

              if (element.classList.contains('text-sec__text--arrow')) {
                start = 0;
                end = 110;
              }

              if (window.innerHeight > 1100) {
                end = 16;
              }

              if (attrValue) {
                const [startStr, endStr] = attrValue.split(',');
                start = parseFloat(startStr) || 0;
                end = parseFloat(endStr) || 0;
              }

              element.style.transform = `translateY(${gsap.utils.interpolate(
                start,
                end,
                progress
              )}vh)`;

              if (element.classList.contains('text-sec__text--arrow')) {
                element.style.transform = `translateY(${gsap.utils.interpolate(
                  start,
                  end,
                  progress
                )}px)`;
              }
            }

            if (isUp) {
              const attrValue = element.getAttribute(
                'data-blur-splitting-to-up'
              );

              let start = 15;
              let end = -20;

              if (attrValue) {
                const [startStr, endStr] = attrValue.split(',');
                start = parseFloat(startStr) || 0;
                end = parseFloat(endStr) || 0;
              }

              element.style.transform = `translateY(${gsap.utils.interpolate(
                start,
                end,
                progress
              )}vh)`;
            }
          },
        },
      });
      trackBlurAnimationHandle(element, tlTransform);

      words.forEach((word, index) => {
        const style = getComputedStyle(word);
        const wordIndex = parseInt(style.getPropertyValue('--word-index'), 10);
        const parent = word.parentElement;
        const isGradient = parent.classList.contains('gradient-cl-animate');
        const currentColor = window.getComputedStyle(word).color;
        const parentGradientLine = word.closest(
          '.gradient-cl-animate.if-line-animation'
        );

        if (parentGradientLine) {
          const wordsArr = parentGradientLine.querySelectorAll('.word');
          for (let i = 0; i < wordsArr.length; i++) {
            wordsArr[wordsArr.length - 1].classList.add(
              'is-trigger-gradient-line'
            );
          }
        }

        let startFilter =
          typeof window !== 'undefined' && window.innerWidth <= 640
            ? 'blur(5px)'
            : 'blur(14px)';
        let endFilter = 'blur(0px)';
        let startOpacity = 0;
        let endOpacity = 1;
        let blurLineApplied = false;

        if (parent.classList.contains('with-bold-logo')) {
          startFilter = 'blur(0px)';
          endFilter = 'blur(0px)';
          startOpacity = 1;
          endOpacity = 1;
        }

        // Вместо index * 0.1, нормализуем по количеству слов
        const relativeDelay = (wordIndex / words.length) * 0.4; // *2 — растягивает

        // Создаем timeline с ScrollTrigger
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: parent, // или другой триггерный элемент
            start: 'top bottom', // начинаем когда верх элемента достигает низа окна
            end: 'bottom 70%', // заканчиваем когда низ элемента на 20% выше низа окна (80% от верха)
            scrub: 1, // привязываем к скроллу
            // Альтернативно, если не нужна привязка к скроллу:
            // toggleActions: "play none none reverse"
          },
        });
        trackBlurAnimationHandle(element, tl);

        tl.fromTo(
          word,
          {
            opacity: startOpacity,
            filter: startFilter,
          },
          {
            opacity: endOpacity,
            filter: endFilter,
            duration: 0.5,
            ease: 'power2.out',
            /*onStart: () => {
                const parentGradientEl = word.closest('.gradient-cl-animate');
                if (parentGradientEl) {
                  parentGradientEl.classList.add('is-line-animation');
                }
              },*/
            onUpdate: function () {
              if (word.classList.contains('is-trigger-gradient-line')) {
                const progress = this.progress();

                if (progress <= 0.5 && blurLineApplied) {
                  parentGradientLine.classList.remove('is-blur-line-animation');
                  blurLineApplied = false;
                } else if (progress >= 0.85 && !blurLineApplied) {
                  parentGradientLine.classList.add('is-blur-line-animation');
                  blurLineApplied = true;
                }
              }
            },
          },
          relativeDelay
        );

        if (parent.classList.contains('with-bold-logo')) {
          const boldLogoEl = parent.closest('.with-bold-logo');

          const relativeDelayBoldLogo = (wordIndex / words.length) * 0.17; // *2 — растягивает
          tl.fromTo(
            boldLogoEl,
            {
              opacity: 0,
              filter:
                typeof window !== 'undefined' && window.innerWidth <= 640
                  ? 'blur(5px)'
                  : 'blur(14px)',
            },
            {
              opacity: 1,
              filter: 'blur(0px)',
              duration: 0.45,
              ease: 'power2.out',
            },
            relativeDelayBoldLogo
          );
        }
      });

      function gradientTextFunc() {
        for (let i = 0; i < words.length; i++) {
          const parentGradient = words[i].closest('.gradient-cl-animate');

          if (parentGradient) {
            const gradientWords = parentGradient.querySelectorAll('.word');
            const targetIndex =
              gradientWords.length > 2
                ? Math.floor(gradientWords.length / 2)
                : gradientWords.length - 1;

            const targetWord = gradientWords[targetIndex];

            const opacity = parseFloat(getComputedStyle(targetWord).opacity);

            if (opacity > 0.85) {
              parentGradient.classList.remove('is-clear-gradient');
            } else {
              parentGradient.classList.add('is-clear-gradient');
            }
          }
        }
      }

      gradientTextFunc();

      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.batch(words, {
          start: 'top bottom',
          end: 'bottom 80%', // Завершаем на 20% раньше от низа окна
          onLeaveBack: (batch) => {
            batch.forEach((word) => word.classList.remove('is-end'));
          },
        }).forEach((trigger) => trackBlurAnimationHandle(element, trigger));
      }
    } else {
      element.setAttribute('data-aos', '');

      if (element.classList.contains('if-fade-in-mobile')) {
        element.classList.add('fade-in-blur-text-aos-animation');
        element.setAttribute('data-aos-offset', '20');
        element.setAttribute('data-aos-once', 'false');
      } else {
        element.classList.add('blur-text-aos-animation');
      }

      // Устанавливаем минимальную и максимальную продолжительность анимации
      const minDuration = 0.4; // Минимальная длительность анимации
      const maxDuration = 0.6; // Максимальная длительность анимации
      const minWords = 2; // Минимальное количество слов
      const maxWords = 14; // Максимальное количество слов

      const wordsCount = Math.min(Math.max(words.length, minWords), maxWords);

      // Линейная интерполяция продолжительности анимации в пределах от 0.5 до 1 секунды
      const duration =
        minDuration +
        (maxDuration - minDuration) *
          ((wordsCount - minWords) / (maxWords - minWords));

      element.style.setProperty('--animation-duration', `${duration}s`);
    }
  });

  if (window.innerWidth <= 1024) {
    setTimeout(() => {
      AOS.refreshHard();
    }, 100);
  }
};

if (!document.querySelector('.bold-loader-new')) {
  initScrollBlurAnimation();
}

const blurTextAosAnimArr = document.querySelectorAll(
  '.blur-text-aos-animation'
);
if (blurTextAosAnimArr.length) {
  blurTextAosAnimArr.forEach((element) => {
    const words = element.querySelectorAll('.word');

    const minDuration = 0.6;
    const maxDuration = 0.7;
    const minWords = 2;
    const maxWords = 14;

    const wordsCount = Math.min(Math.max(words.length, minWords), maxWords);

    const duration =
      minDuration +
      (maxDuration - minDuration) *
        ((wordsCount - minWords) / (maxWords - minWords));

    element.style.setProperty('--animation-duration', `${duration}s`);
  });
}

window.blurLineAnimFunc = function blurLineAnimFunc() {
  const blurLineAnimElArr = document.querySelectorAll(
    '.gradient-cl-animate.if-line-animation'
  );

  if (!blurLineAnimElArr.length) return;

  if (window.innerWidth >= 1025) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        if (!entry.isIntersecting) {
          el.classList.remove('is-blur-line-animation');
          return;
        }

        // если вошёл в зону видимости → вешаем с задержкой
        setTimeout(
          () => {
            el.classList.add('is-blur-line-animation');
          },
          window.innerWidth > 1024 ? 1000 : 3000
        );
      });
    },
    { threshold: 0.85 }
  ); // 85% видимости

  blurLineAnimElArr.forEach((el) => observer.observe(el));
};

if (!document.querySelector('.bold-loader-new')) {
  blurLineAnimFunc();
}
